<template>
  <div>
    <div v-if="notices.length === 0">
      <b-alert show variant="info">
        No signed notices found.
      </b-alert>
    </div>
    <div v-else>
      <b-table small responsive striped hover :items="notices" :fields="table_fields">
        <template #cell(id)="data">
          <b-button variant="outline-primary" size="sm" @click="onShowSignedNotice(data.value)">
            Confirmation
          </b-button>

        </template>

        <template #cell(results)="data">
          <b-button variant="outline-primary" size="sm" @click="showNoticeSampleResults(data.item.id)">
            Results
          </b-button>
        </template>


        <template #cell(notice)="data">
          <b-button variant="outline-primary" size="sm" @click="onShowNoticeReport(data.item.id)">
            Notice #{{ data.item.id }}
          </b-button>

        </template>

      </b-table>
    </div>

    <b-modal id="notice-report-modal" size="xl" :title="show_notice_report_title" hide-footer>
      <object width="100%" height="600px" :data="show_notice_report_url" type="application/pdf">
        <p>
          Unable to display PDF file.
          <a :href="show_notice_report_url">Download</a> instead.
        </p>
      </object>
    </b-modal>

    <b-modal id="notice-samples-modal" size="xl" :title="show_notice_samples_report_title" hide-footer>
      <object width="100%" height="600px" :data="show_notice_samples_report_url" type="application/pdf">
        <p>
          Unable to display PDF file.
          <a :href="show_notice_samples_report_url">Download</a> instead.
        </p>
      </object>
    </b-modal>

  </div>
</template>

<script>
export default {
  name: "SignedNotices",
  props: {
    pws_id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      notices: [],
      show_notice_report_title: "",
      show_notice_report_url: "",
      // notice samples report
      show_notice_samples_report_url: null,
      show_notice_samples_report_title: "Notice Sample Results",
      table_fields: [
        { key: "id", label: "Notice Confirmation" },
        { key: "results", label: "Results" },
        'notice',
        { key: "mp_name", label: "Monitoring Period" },
        { key: "data_signame", label: "Signed By" },
        { key: "data_signame_title", label: "Signed Title" },
        { key: "data_signature_ts", label: "DT Signed" },
      ],
    }
  },
  mounted() {
    this.getSignedNotices();
  },
  methods: {
    async getSignedNotices() {
      const url =
        process.env.VUE_APP_API_URI +
        "/lc-notice/notices?pws_id=" +
        this.pws_id + "&signed=true";
      try {
        const res = await this.axios.get(url);
        console.log(res);
        this.notices = res.data.notices;
        for (const notice of this.notices) {
          notice.data_signature_ts = new Date(notice.data_signature_ts).toLocaleString();
        }
      } catch (error) {
        console.error(error);
      }
    },
    onShowNoticeReport(notice_id) {
      console.log("onShowNoticeReport", notice_id);
      this.show_notice_report_url =
        process.env.VUE_APP_API_URI +
        "/lc-notice/notices/" +
        notice_id +
        "/report";
      // construct the title
      this.show_notice_report_title = `Sample Notice - ${this.pws_label}`;
      this.$bvModal.show("notice-report-modal");
    },
    onShowSignedNotice(notice_id) {
      console.log("onShowSignedNotice", notice_id);
      this.show_notice_report_title = "Lead/Copper Notice Confirmation - " + this.pws_id_signed_in;
      this.show_notice_report_url =
        process.env.VUE_APP_API_URI +
        "/lc-notice/notices/" +
        notice_id +
        "/confirmation";
      this.$bvModal.show("notice-report-modal");
    },
    showNoticeSampleResults(notice_id) {
      this.show_notice_samples_report_url =
        process.env.VUE_APP_API_URI +
        "/lc-notice/notices/" +
        notice_id +
        "/samples/report";
      console.log(this.show_notice_samples_report_url);
      // construct the title
      this.show_notice_samples_report_title = `Sample Results - ${this.pws_label}`;
      this.$bvModal.show("notice-samples-modal");
    },

  },
  computed: {
    pws_label() {
      return `${this.$store.state.pws_id} -${this.$store.state.pws.pws_name}`;
    },
    pws_id_signed_in() {
      return this.$store.state.pws_id;
    },
  },
};
</script>
